import { render } from "./SimpleTextInput.vue?vue&type=template&id=4be5d334&lang=true"
import script from "./SimpleTextInput.vue?vue&type=script&lang=js"
export * from "./SimpleTextInput.vue?vue&type=script&lang=js"
script.render = render

export default script